import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import MinutesToHoursInput from '@/se/components/inputs/MinutesToHoursInput';

export default compose(
  withLabel('Daily capacity in minutes'),
  withProps({ placeholder: 'e.g., 8' })
)(MinutesToHoursInput);
